import { callApi } from "@src/api/callApi"
import { THEFT } from "@src/api/types"

export type POST_THEFTS_BODY = {
  circumstanceofcrime: string
  specialfeatures: string
  stolen_timestamp_from?: string
  stolen_timestamp_to?: string
  police_case_number?: string | null
}

export const postPartnerDeviceSerialnumberThefts = (
  partnerUuid: string,
  serialnumber: string,
  body: POST_THEFTS_BODY,
) =>
  callApi<POST_THEFTS_BODY, THEFT>({
    method: "POST",
    path: `/partner/${partnerUuid}/device/${serialnumber}/thefts`,
    body,
  })
